import 'font-awesome/css/font-awesome.css';
import './css/site.css';
import './webpack-component-loader';
import * as ko from 'knockout';

import ShellComponent, { ShellViewModelParams } from './components/shell/shell';
import { Application } from "./services/application";
import OidcManager from "./services/api/oidcManager";
import { getConfig, createOidcSettings } from "./oidcConfig";

const oidcManager = new OidcManager(createOidcSettings());

console.log(`boot.ts, location: ${window.location}`);
const isCallback =
    window.location.search.includes("code=") ||
    window.location.search.includes("error=");

if (isCallback) {
    console.log("OIDC CALLBACK");
    oidcManager.signinRedirectCallback()
        .then(user => {
            console.log("USER:", user);
            window.history.replaceState({}, document.title, "/");
            // start app after OIDC callback is processed
            startApp();
        })
        .catch(err => console.error(err));
} else {
    console.log("authorizing...");
    //starts app if client is already authorized
    oidcManager.authorize().then(startApp);
}

function startApp() {
    ko.components.register('shell', ShellComponent);
    ko.applyBindings(<ShellViewModelParams>{
        app: new Application(getConfig(), oidcManager)
    });
    if (module.hot) {
        module.hot.accept();
        module.hot.dispose(() => ko.cleanNode(document.body));
    }
}


// WEBPACK FOOTER //
// ./ClientApp/boot.ts